import React, { useState } from 'react';
import { ManageModal } from './ManageModal';

const Manage = ({ type = 'reference-data', tableProps = {}, className = '' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className={`px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors ${className}`} onClick={() => setOpen(true)}>
        Manage
      </button>
      <ManageModal type={type} open={open} onClose={() => setOpen(false)} tableProps={tableProps} />
    </>
  );
};

export { Manage }; 